import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/global.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import {
  clearReloadCount,
  hardReloadForStaleAssets,
  isChunkLoadError,
  purgeStaleServiceWorkers,
} from "./lib/staleAssets";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

// If we reached React without crashing, the assets are definitely current —
// drop the one-shot reload counter so a future stale-asset blip can recover.
clearReloadCount();

// Defensive: scrub any leftover service worker / Cache Storage from prior
// experiments so returning visitors aren't stuck with a stale shell.
void purgeStaleServiceWorkers();

// Catch dynamic-import failures that bubble up outside of React's tree
// (e.g. from a deferred route transition).
window.addEventListener("unhandledrejection", (event) => {
  if (isChunkLoadError(event.reason)) {
    hardReloadForStaleAssets();
  }
});

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
